import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { GlobalConfigCesComponent } from './crud-ces/crud-ces.component';
import { GlobalConfigService } from './crud-service';

@NgModule({
  declarations: [GlobalConfigCesComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    DynamicFormModule,
    DialogContainerModule,
    FieldsModule,
  ],
  providers: [GlobalConfigService],
  exports: [GlobalConfigCesComponent]
})
export class GlobalConfigModule {}
